module.exports = __webpack_public_path__ + "img/cost.42964be5.png";